const obj = {};
obj.SWCJOptions = [
  {
    value: 100000,
    name: '10万'
  },
  {
    value: 200000,
    name: '20万'
  },
  {
    value: 300000,
    name: '30万'
  },
  {
    value: 400000,
    name: '40万'
  },
  {
    value: 500000,
    name: '50万'
  },
  {
    value: 600000,
    name: '60万'
  },
  {
    value: 700000,
    name: '70万'
  },
  {
    value: 800000,
    name: '80万'
  },
  {
    value: 900000,
    name: '90万'
  },
  {
    value: 1000000,
    name: '100万'
  }
];
// 10-100
obj.oneSCOptions = [
  {
    value: 0,
    name: '不附加'
  },
  {
    value: 100000,
    name: '10万'
  },
  {
    value: 200000,
    name: '20万'
  },
  {
    value: 300000,
    name: '30万'
  },
  {
    value: 400000,
    name: '40万'
  },
  {
    value: 500000,
    name: '50万'
  },
  {
    value: 600000,
    name: '60万'
  },
  {
    value: 700000,
    name: '70万'
  },
  {
    value: 800000,
    name: '80万'
  },
  {
    value: 900000,
    name: '90万'
  },
  {
    value: 1000000,
    name: '100万'
  }
];
// 10-50
obj.KYQCYWOptions = [
  {
    value: 0,
    name: '不附加'
  },
  {
    value: 100000,
    name: '10万'
  },
  {
    value: 200000,
    name: '20万'
  },
  {
    value: 300000,
    name: '30万'
  },
  {
    value: 400000,
    name: '40万'
  },
  {
    value: 500000,
    name: '50万'
  }
];
obj.YLFYOptions = [
  {
    value: 0,
    name: '不附加',
    disabled: false
  },
  {
    value: 10000,
    name: '1万',
    disabled: false
  },
  {
    value: 20000,
    name: '2万',
    disabled: false
  },
  {
    value: 30000,
    name: '3万',
    disabled: false
  },
  {
    value: 40000,
    name: '4万',
    disabled: false
  },
  {
    value: 50000,
    name: '5万',
    disabled: false
  },
  {
    value: 60000,
    name: '6万',
    disabled: false
  },
  {
    value: 70000,
    name: '7万',
    disabled: false
  },
  {
    value: 80000,
    name: '8万',
    disabled: false
  },
  {
    value: 90000,
    name: '9万',
    disabled: false
  },
  {
    value: 100000,
    name: '10万',
    disabled: false
  },
  {
    value: 110000,
    name: '11万',
    disabled: false
  },
  {
    value: 120000,
    name: '12万',
    disabled: false
  },
  {
    value: 130000,
    name: '13万',
    disabled: false
  },
  {
    value: 140000,
    name: '14万',
    disabled: false
  },
  {
    value: 150000,
    name: '15万',
    disabled: false
  },
  {
    value: 160000,
    name: '16万',
    disabled: false
  },
  {
    value: 170000,
    name: '17万',
    disabled: false
  },
  {
    value: 180000,
    name: '18万',
    disabled: false
  },
  {
    value: 190000,
    name: '19万',
    disabled: false
  },
  {
    value: 200000,
    name: '20万',
    disabled: false
  },
];
obj.columns = [

  {
    title: '序号',
    scopedSlots: { customRender: 'num' }
  },
  {
    title: '姓名',
    dataIndex: 'name'
  },
  {
    title: '证件类型',
    dataIndex: 'idType',
    key: 'idType',
    scopedSlots: { customRender: 'idType' }
  },
  {
    title: '证件号码',
    dataIndex: 'idNumber'
  },
  {
    title: '出生日期',
    dataIndex: 'birthDate'
  },
  {
    title: '性别',
    dataIndex: 'gender',
    key: 'gender',
    scopedSlots: { customRender: 'gender' }
  },
  {
    title: '职业代码',
    dataIndex: 'occupationCode'
  },
  {
    title: '职业名称',
    dataIndex: 'occupationName'
  },
  {
    title: '职业类别',
    dataIndex: 'occulevel',
    scopedSlots: { customRender: 'occulevel' }
  }
];
obj.companyIdTypeOptions = [
  {
    value: '03',
    name: '统一社会信用代码'
  }
];
//处理证件类型
obj.getterIdtype = function(value) {
  switch (value) {
    case '身份证':
    case '01':
    case 1:
    case '1':
      return '身份证';
    case '护照':
    case '护照号':
    case '02':
    case '2':
    case 0:
      return '护照';
    case '其它':
    case '99':
    case 99:
      return '其它';
    case '06':
    case '6':
    case 6:
      return '港澳回乡证或台胞证';
    default:
      return '身份证';
  }
};
obj.guarantPre = [
  // 投保期限
  {
    key: 1,
    value: '1个月'
  },
  {
    key: 3,
    value: '3个月'
  },
  {
    key: 6,
    value: '6个月'
  },
  {
    key: 12,
    value: '12个月'
  }
];
obj.sexOptions = [
  //性别
  {
    name: '男',
    value: 'M'
  },
  {
    name: '女',
    value: 'F'
  }
];
obj.occupationNumberList = [
  // 试算职业类别
  {
    occupationKind: '1类',
    personNum: 0
  },
  {
    occupationKind: '2类',
    personNum: 0
  },
  {
    occupationKind: '3类',
    personNum: 0
  },
  {
    occupationKind: '4类',
    personNum: 0
  },
  {
    occupationKind: '5类',
    personNum: 0
  },
  {
    occupationKind: '6类',
    personNum: 0
  }
];
obj.occupationOptionsLevel = [
  {
    //职业类别
    //职业类别
    name: '1类',
    value: '1'
  },
  {
    name: '2类',
    value: '2'
  },
  {
    name: '3类',
    value: '3'
  },
  {
    name: '4类',
    value: '4'
  },
  {
    name: '5类',
    value: '5'
  },
  {
    name: '6类',
    value: '6'
  }
];
//过滤身份证信息的公共方法
obj.filterAllINTYPE = function(idType) {
  switch (idType) {
    case '身份证':
    case '01':
    case 1:
    case '1':
      return '1';
    case '护照':
    case '护照号':
    case '02':
    case '2':
    case 0:
      return '2';
    case '港澳回乡证或台胞证':
    case '06':
    case '6':
    case 6:
      return '06';
    case '其它':
    case '99':
    case 99:
      return '99';
    default:
      return '1';
  }
};

//处理性别
obj.getterGender = function(value) {
  switch (value) {
    case 'M':
    case '男':
      return '男';
    case 'F':
    case '女':
      return '女';
    default:
      return '男';
  }
};
//反转对象
obj.resoverObj = function(obj) {
  var a = {
    '1类': 0,
    '2类': 0,
    '3类': 0,
    '4类': 0,
    '5类': 0,
    '6类': 0,
  };
  for (const key in obj) {
    a[key] = obj[key];
  }
  return a;
};
//提交的去重
obj.unique = function(arr, attribute) {
  var new_arr = [];
  var json_arr = [];
  for (var i = 0; i < arr.length; i++) {
    if (new_arr.indexOf(arr[i][attribute]) == -1) {
      //  -1代表没有找到
      new_arr.push(arr[i][attribute]); //如果没有找到就把这个name放到arr里面，以便下次循环时用
      json_arr.push(arr[i]);
    }
  }
  return json_arr;
};

//计算总保费
obj.sumZfeiyong = function(content, riskNumber) {
  
  
  var jichu = {
    '1类': 0,
    '2类': 0,
    '3类': 0,
    '4类': 0,
    '5类': 0,
    '6类': 0
  };
  for (const key in content) {
    jichu[key] = Number(content[key]) * Number(riskNumber[key] || 0);
  }
  
  return jichu;
};
export default obj;
